import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import { VotingContext } from "./VotingNavigation";
import { api } from "../../api/api";
import { Dimensions, Text, View } from "react-native";
import { colors } from "../../common/styles/colors";
import { MascotBlack } from "../../common/icons/mascot_black";
import { CommonButton } from "../../components/buttons";
import { fonts } from "../../common/styles/fonts";
import { StyleSheet } from "react-native";

export const PhonePage = () => {
  const { voteId, meeting } = useContext(VotingContext);

  const navigate = useNavigate();
  const [phone, setPhone] = useState("");

  useEffect(() => {
    if (!voteId) {
      navigate("../app/", { replace: true });
    }
  }, [voteId]);

  const updateUserPhone = () => {
    voteId &&
      meeting &&
      api.meetings
        .putApiMeetingsIdUpdateVotePhoneVoteId(
          meeting.id,
          voteId?.toString() || "",
          {
            phone,
          }
        )
        .then((res) => {
          if (res.data) {
            navigate(`../gaddering/${meeting.uuid}`);
          }
        });
  };

  return (
    <View
      style={{
        height: Dimensions.get("window").height,
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <View style={styles.screen}>
        <MascotBlack />
        <Text
          style={[
            fonts.largeText_bold,
            {
              marginBottom: 8,
              marginTop: 24,
            },
          ]}
        >
          Stay in the loop.
        </Text>
        <Text style={fonts.mediumText_regular}>
          Enter your phone number below.
        </Text>
        <View style={{ paddingLeft: 20, paddingRight: 20 }}>
          <PhoneInput
            containerStyle={{
              maxWidth: 700,
            }}
            inputStyle={styles.input}
            specialLabel=""
            country="gb"
            placeholder="Enter phone number"
            value={phone}
            onChange={(phone) => setPhone(phone)}
          />
        </View>
        <Text style={[fonts.mediumText_regular, { textAlign: "center" }]}>
          We’ll send you all the info <br /> and updates about this invite.
        </Text>
        <View style={styles.buttonContainer}>
          <CommonButton
            type="blackNonBordered"
            size="medium"
            title="Skip"
            textStyle={fonts.mediumText_bold}
            onPress={() => meeting && navigate(`../gaddering/${meeting.uuid}`)}
          />
          <CommonButton
            type="black"
            size="medium"
            title="Done"
            textStyle={fonts.mediumText_bold}
            onPress={() => updateUserPhone()}
          />
        </View>
      </View>
    </View>
  );
};
const styles = StyleSheet.create({
  screen: {
    height: "100%",
    maxWidth: 500,
    width: "100%",
    paddingLeft: 26,
    paddingRight: 26,
    alignItems: "center",
    paddingTop: 86,
  },
  input: {
    width: "100%",
    border: 0,
    height: 46,
    borderRadius: 15,
    fontSize: 20,
    marginTop: 30,
    marginBottom: 30,
    backgroundColor: colors.LightGrayishYellow,
  },
  buttonContainer: {
    marginTop: 105,
    maxWidth: 700,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
});
